import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { isBlank, isPresent } from '@fretadao/f-js-utils';
import { findAll, find, addClass, removeClass } from '@fretadao/f-js-dom';

application.register('communication', class extends Controller {
  static targets = ['preview', 'template', 'submit'];

  connect() {
    $(this.templateTargets).on('change', this.#changePreview);
  }

  submit() {
    const emptyFields = findAll(`#template-items-${this.templateTarget.value} input`).filter((i) => isBlank(i.value));
    if(isPresent(emptyFields)) event.stopImmediatePropagation();
  }

  #changePreview(event) {
    const channel = event.target.dataset.channel;
    const item = find(`#${channel}_name`);
    const templateSelected = event.target[event.target.selectedIndex].text;
    const templateId = event.target.value;

    findAll('#whatsapp_zendesk .templates-panel input[required]').forEach((i) => i.removeAttribute('required'));
    findAll(`#template-items-${templateId} input`).forEach((i) => i.setAttribute('required', true));

    if (templateSelected && templateSelected != 'true') {
      item.innerText = `Será enviado template ${templateSelected}`;
      addClass(item, 'description-target');
      item.setAttribute('description-content', `${channel}: ${templateSelected}`);
    } else {
      item.innerText = 'Não será enviado';
      removeClass(item, 'description-target');
      item.removeAttribute('description-content');
    }
  }
});
